import {
	ADMINDELETECURRENCYMAPPING_SUCCESS,
	ADMINDELETECURRENCYMAPPING_FAILED,
	RESET_ADMINDELETECURRENCYMAPPING,
	LOADING_ADMINDELETECURRENCYMAPPING,
	NETWORK_ERROR_ADMINDELETECURRENCYMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminDeleteCurrencyMapping = () => {
	return { type: RESET_ADMINDELETECURRENCYMAPPING };
};

const adminDeleteCurrencyMapping =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINDELETECURRENCYMAPPING });
		await adminServices
			.post("deleteCurrencyMapping", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminDeleteCurrencyMappingsuccess(res.data));
						break;
					default:
						dispatch(adminDeleteCurrencyMappingFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINDELETECURRENCYMAPPING,
					payload: err
				});
			});
	};
function adminDeleteCurrencyMappingsuccess(data) {
	return {
		type: ADMINDELETECURRENCYMAPPING_SUCCESS,
		payload: data
	};
}
function adminDeleteCurrencyMappingFailed(data) {
	return {
		type: ADMINDELETECURRENCYMAPPING_FAILED,
		payload: data
	};
}

export { resetAdminDeleteCurrencyMapping, adminDeleteCurrencyMapping };
